<div class="warp">
  <div id="list-2" cdkDropList class="board-edit" [cdkDropListData]="stepForm.controls.questions.controls"
    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered($event)" (cdkDropListExited)="onDragExit()"
    cdkDropListAutoScrollDisabled="false" cdkDropListAutoScrollStep="10" *ngIf="length$()>0; else noChoose">
    <que-definitions-in-board [isEdit]="true"></que-definitions-in-board>
    <ng-container *ngFor="let q of stepForm.controls.questions.controls,let i = index">
      <div cdkDrag [cdkDragData]="q" [cdkDragLockAxis]="'y'" class="wrap-drag"  [ngClass]="{'followUpQuestion':q.value?.parentFollowUpQuestionId!=null}">
        <div class="follow-up-title" *ngIf="q.value?.parentFollowUpQuestionId!=null">
          <p class="no-warp" translate>followQuestion.follow-to-option</p>
          <p class="option">
            {{getOptionToQuestionById(q.value?.parentFollowUpQuestionId,q.value?.followAnswerOptionItemGuid)}}</p>
        </div>
        <div class="drag-box"
          [ngClass]="{'focus':(focusId$ | async) ==i}"  (click)="focus($event,i)" (mousedown)="onCenterMouseDown()">
          <div class="handle scale-img-he" cdkDragHandle>
            <img *ngIf="(focusId$ | async) ==i" src="/assets/images/new-display/drag.svg">
            <img *ngIf="(focusId$ | async) !=i" src="/assets/images/new-display/drag-black.svg">
          </div>
          <que-warp-question class="question-form" (deleteMeEvent)="deleteQuestion(i)"
            (dupliacteQuestionEvent)="duplicate(i)" [index]="i" [formControl]="q"></que-warp-question>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #noChoose>
  <div class="board-edit">
    <que-definitions-in-board [isEdit]="true"></que-definitions-in-board>
    <div class="empty">
      <h2 translate>finish.empty</h2>
      <p translate>finish.drag</p>
      <div cdkDropList (cdkDropListDropped)="drop($event)" class="dragArea">
        <div class="warp-img"> <img src="/assets/images/plus_drag.svg"></div>
      </div>
    </div>
  </div>
</ng-template>